import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import ButtonLoadingSpinner from "../components/loader/ButtonLoadingSpinner";
import Logo from "../assets/logo.png";
import * as Yup from 'yup'; // Import Yup for form validation
import Input from "../components/ui/input";
import { clearError, logINAction } from "../redux/actions/authActions";
import Button from "../components/ui/button";
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const SignIn = () => {
  const {t }= useTranslation('common');
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  const [formData, setFormData] = useState({
    Email: "",
    Password: ""
  });
  const [errors, setErrors] = useState({}); // State to hold validation errors

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const error = useSelector((state) => state.auth?.error);
  const userData = useSelector(state => state.auth?.userData || null);
  useEffect(() => {
    dispatch(clearError()); // Dispatch clearError action when component unmounts
  }, []); // Empty dependency array to mimic componentDidMount behavior

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Reset error for the current field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined // Clear error for the current field
    }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };
  useEffect(() => {
    if (!userData) { return; }
    navigate("/select-site", { replace: true })
  }, [navigate, userData])

  const schema = Yup.object().shape({
    Email: Yup.string().email("Email is not valid").required("Email is required"),
    Password: Yup.string().required("Password is required")
  });

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    await schema.validate(formData, { abortEarly: false });
    setLoading(true);
    setLoadingText("Signing in...");

    const timeout = setTimeout(() => {
      setLoadingText("This is taking longer than usual. Please wait.");
    }, 5000);

    await dispatch(logINAction(formData.Email, formData.Password));

    clearTimeout(timeout);
  } catch (error) {
    // Validation errors
    if (error.inner && Array.isArray(error.inner)) {
      const errors = {};
      error.inner.forEach((e) => {
        errors[e.path] = e.message;
      });
      setErrors(errors);
    } else {
      // Login/authentication error -- error.message is the clean backend
      // detail (logINAction throws with it), e.g. "This company's access
      // has been suspended." or "This account has been suspended.", not
      // just a generic bad-credentials message.
      toast.error(error.message || "Incorrect email or password. Please try again.");
      console.error("Login error:", error);
    }
  } finally {
    // Always reset loading, so the button is enabled again
    setLoading(false);
  }
};


  return (
    <section className="bg-white">
      <div className="container mx-auto flex min-h-screen items-center justify-center px-6">
        <form className="w-full max-w-md" onSubmit={handleSubmit}>
          <div className="mx-auto flex justify-center">
            <img className="h-20 w-auto sm:h-20" src={Logo} alt="" />
          </div>

          <div className="mt-6 flex items-center justify-center">
            <h1 className="font-medium text-center text-2xl text-gray-800">{t('login')}</h1>
          </div>
          <div className="relative mt-8 flex items-center">
            <Input
              id="Email"
              name="Email"
              type="text"
              value={formData.Email}
              error={errors.Email}
              onChange={handleChange}
              className={`w-full   mx-11  text-gray-700 `}
              placeholder={t('email')}
              autoComplete="off"
            />
          </div>
          <div className="relative w-full mt-8 flex items-center">
            <Input
              id="Password"
              name="Password"
              type="password"
              value={formData.Password}
              error={errors.Password}
              onChange={handleChange}
              className={` w-full mx-11 text-gray-700  `}
              placeholder={t('password')}
              autoComplete="off"
            />
          </div>
          {typeof error === "string" && error && (
            <span className="block top-7 my-4 mx-11 text-xs text-[#FF0000] bottom-0">* {error}</span>
          )}
          <div className="ml-12 mt-5">
            <Link to={"/passwordRecovery"} className="font-normal text-[#0071BC] text-sm">{t('forget_password')}</Link>
          </div>

          <div className="mt-16">
            <Button
              disabled={loading}
              type="submit"
              className={`w-full transform rounded-3xl bg-gradient-to-r from-[#0071BC] to-[#08173B] px-6 py-3 text-sm font-medium tracking-wide text-white transition-colors duration-300 hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50 ${
                loading ? "cursor-not-allowed opacity-50" : ""
              }`}
            >
              {t("login")}
            </Button>

            <div className="my-6 flex items-center justify-center">
              <Link
                to="/signup"
                className="text-sm font-normal text-[#0071BC]"
              >
                {t("don_t_have_an_account_create_an_account")}
              </Link>
            </div>
          </div>

          <p className="mt-4 text-center text-[11px] text-gray-800">-SolyntekAi-</p>
        </form>
      </div>
    </section>
  );
};

export default SignIn;
